import { useQuery } from "@apollo/client/react";
import React, { ReactNode, JSX } from "react";

import AppContext from "../app";
import { CATALOGS_QUERY } from "queries/common";

// MAIN COMPONENT

type AppProviderProps = {
  children: ReactNode;
};

const AppProvider = ({ children }: AppProviderProps): JSX.Element => {
  const catalogues = useQuery(CATALOGS_QUERY);

  return (
    <AppContext.Provider
      value={{
        catalogues: catalogues.data || {},
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
